import { RemoteHandleTeamReport } from 'data/usecases';
import { HandleTeamReport } from 'domain/usecases';
import { makeApiUrlTeamReport } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeHandleTeamReport = (): HandleTeamReport =>
  new RemoteHandleTeamReport(makeApiUrlTeamReport(), makeAxiosHttpClient());
